module.exports = __webpack_public_path__ + "static/img/次元兽决战2.0290f67c.png";